// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/create-iter-result-object.js
// module id = 431
// module chunks = 0